import { Configuration, LogLevel } from "@azure/msal-browser";
import { AzureConfigValues } from "../common/interfaces";

const env: AzureConfigValues = process.env as AzureConfigValues;

const msalConfig: Configuration = {
	auth: {
		clientId: env.REACT_APP_AZURE_CLIENT_ID ?? "",
		authority: env.REACT_APP_AZURE_AUTHORITY,
		knownAuthorities: env.REACT_APP_AZURE_KNOWN_AUTHORITY
			? [env.REACT_APP_AZURE_KNOWN_AUTHORITY]
			: [],
		redirectUri: env.REACT_APP_REDIRECT_URL,
		postLogoutRedirectUri: "/",
		navigateToLoginRequestUrl: false,
	},
	cache: {
		cacheLocation: "localStorage",
		storeAuthStateInCookie: false,
	},
	system: {
		loggerOptions: {
			loggerCallback: (
				level: LogLevel,
				message: string,
				containsPii: boolean
			) => {
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					case LogLevel.Info:
						console.info(message);
						return;
					case LogLevel.Verbose:
						console.debug(message);
						return;
					case LogLevel.Warning:
						console.warn(message);
						return;
					default:
						return;
				}
			},
		},
	},
};

const loginRequest = {
	scopes: [
		"openid",
		"offline_access",
		env.REACT_APP_SCOPE !== undefined ? env.REACT_APP_SCOPE : "",
	],
};

const tokenRequest = {
	scopes: [
		"openid",
		"offline_access",
		env.REACT_APP_SCOPE !== undefined ? env.REACT_APP_SCOPE : "",
	],
	forceRefresh: false,
};

export { msalConfig, loginRequest, tokenRequest };
